import { date, number, object, string } from 'yup';
import { l10n as naoL10n } from '../l10n/newAccount';
import { mapL10nKeys } from '../../common/util/l10n';

export function getNewAccountSchema() {

  const DEFAULT_TEXT_FIELD_REGEX = /^[^~`<>|@+="\\/]+$/;
  // njansen 5/13/22 - jankety solution to make l10n work without app bootstrap, this needs called on every page requiring l10n
  const l10n = mapL10nKeys(naoL10n);

  // njansen 6/16/22 - l10n.textFieldValidation should be using the common definition, remove when bundled with web
  return object().shape({
    accountProduct: string()
      .required(l10n.validation.accountProductRequired),
    firstName: string()
      .matches(DEFAULT_TEXT_FIELD_REGEX, l10n.textFieldValidation)
      .required(l10n.validation.firstNameRequired).max(18),
    middleName: string()
      .test('middleName', l10n.textFieldValidation, (middleName: String) => !middleName || DEFAULT_TEXT_FIELD_REGEX.test(middleName.toString())),
    lastName: string()
      .matches(DEFAULT_TEXT_FIELD_REGEX, l10n.textFieldValidation)
      .required(l10n.validation.lastNameRequired).max(40),
    address1: string()
      .matches(DEFAULT_TEXT_FIELD_REGEX, l10n.textFieldValidation)
      .required(l10n.validation.address1Required),
    address2: string()
      .test('address2', l10n.textFieldValidation, (address2: String) => !address2 || DEFAULT_TEXT_FIELD_REGEX.test(address2.toString())),
    city: string()
      .matches(DEFAULT_TEXT_FIELD_REGEX, l10n.textFieldValidation)
      .required(l10n.validation.cityRequired),
    state: string()
      .required(l10n.validation.stateRequired),
    zip: string()
      .required(l10n.validation.zipRequired)
      .min(5, l10n.validation.zipLength)
      .max(5, l10n.validation.zipLength),
    ssnLastFour: string().when('dateOfBirth', {
      is: (dateOfBirth: String) => !dateOfBirth,
      then: string()
        .required(l10n.validation.dateOfBirthOrSsnLastFourRequired)
        .min(4, l10n.validation.ssnLastFourLength)
        .max(4, l10n.validation.ssnLastFourLength),
    }),
    dateOfBirth: date().nullable()
      .when('ssnLastFour', {
        is: (ssnLastFour: String) => !ssnLastFour || !(ssnLastFour.length === 4),
        then: date()
          .required(l10n.validation.dateOfBirthOrSsnLastFourRequired),
      }),
    email: string()
      .required(l10n.validation.emailRequired)
      .email(l10n.validation.emailInvalid),
    primaryPhone: string()
      .required(l10n.validation.primaryPhoneRequired)
      .min(10, l10n.validation.primaryPhoneLength)
      .max(10, l10n.validation.primaryPhoneLength),
    depositSource: string()
      .required(l10n.validation.depositSourceRequired),
    amount: number()
      .typeError(l10n.validation.amountRequired)
      .required(l10n.validation.amountRequired)
      .min(0.01, l10n.validation.amountMin)
      .max(999999999.99, l10n.validation.amountMax),
  },
    [
      ['ssnLastFour', 'dateOfBirth'],
    ]);
}